// @see http://opurs.hz.netease.com/docDetail.html?pid=387#/

import { ursConfig, mobileService } from '../../common-scripts/urs_config'
import { requestMethod } from '../../common-scripts/request'
import loginSuccMethods from '../../common-scripts/ursLoginSuccMethod'
import logger from '../../common-scripts/logger'
import { createComponentBroadcast } from '../../common-scripts/componentBroadcast'
import ursComponentTab from './ursComponentTab'
import ursCssFiles from '../../common-scripts/ursCssFiles'

const { actions } = ursComponentTab
const componentTabBroadcast = createComponentBroadcast(ursComponentTab)

function ursInitRefresh(selector: string, initFn: () => void): void {
  $(selector).empty()
  initFn()
}

function loginSuccCb(): void {
  const url = '/j_spring_security_check'
  const methods = 'POST'
  requestMethod(url, methods)
    .then((data) => {
      loginSuccMethods(data)
    })
    .catch((err) => {
      logger.log(err)
    })
}

function createMessageLogin(): void {
  new URS({
    ...ursConfig,
    cssFiles: ursCssFiles.messageLogin, //可选，产品自定义css的文件路径 /path/x.css,/path/xx.css，必须是https协议
    includeBox: 'include-message', // 必须，登陆框的外层节点的id
    // regText: '注册吗',
    page: 'login', // 可选，首屏显示登录，可选register
    //single : 1, // 可选，只接入登录或注册模块
    aiCapPadding: 10, //【可选】指定无感知弹出来框的padding值
    aiCapBarHeight: 40, //【可选】指定无感知弹出来框顶部的高度
    aiCapWidth: 260, //【可选】指定无感知弹出来框的宽度,最小260
    skin: 0, // 皮肤
    needPrepare: 0, //【可配】是否需要预加载（针对弹框式，在产品方DOM加载完成后初始化加载组件先行资源，保证显示时间在50ms内，会有一定的带宽占用，按需配置）
    autoFocus: 1, //普通邮箱帐号登录，选择帐号后是否自动聚焦到密码输入框。默认否
    needMobileLogin: 1, // 需要手机帐号登录模块
    mobileFirst: 1, // 手机帐号相关模块优先展示
    regcb: function(username: string): void {
      // 可选，注册成功回调，后续要使用组件要重新初始化
      ursInitRefresh('#include-message', createMessageLogin)
      logger.log(username)
    },
    //手机账号登录+注册
    uniteLogin: {
      unLoginTxt: '自动登录', //免登文案
      loginTxt: '确定', // 登录按钮文案
      placeholders: {
        mob: '手机号',
        sms: '验证码',
      },
      first: 1, //是否统一登录是首屏，否则密码登录为首屏
      clause: 0, // 条款默认是否勾选
      needClause: 1, // 是否需要条款
      needUnLogin: 1, //是否需要免登录
      unLoginTime: 10, //免登时间
      unLoginDefautl: 0, //免登是否默认勾选
      uniteLoginTermsList: mobileService,
    },
    logincb: function(
      _username: string,
      _isOther: boolean /*, _data: any*/,
    ): void {
      try {
        loginSuccCb()
        logger.log('用户名:' + _username)
        logger.log('是否第三方登录:' + _isOther)
      } catch (e) {
        logger.log(e)
      }
      logger.log(_username)
      ursInitRefresh('#include-message', createMessageLogin)
    },
  })
}

function createPasswordLogin(): void {
  new URS({
    ...ursConfig,
    cssFiles: [ursCssFiles.messageLogin, ursCssFiles.passWordLogin], //可选，产品自定义css的文件路径 /path/x.css,/path/xx.css，必须是https协议
    includeBox: 'include-phone-password', // 必须，登陆框的外层节点的id
    page: 'login', // 可选，首屏显示登录，可选register
    //single : 1, // 可选，只接入登录或注册模块
    aiCapPadding: 10, //【可选】指定无感知弹出来框的padding值
    aiCapBarHeight: 40, //【可选】指定无感知弹出来框顶部的高度
    aiCapWidth: 260, //【可选】指定无感知弹出来框的宽度,最小260
    skin: 0, // 皮肤
    needPrepare: 0, //【可配】是否需要预加载（针对弹框式，在产品方DOM加载完成后初始化加载组件先行资源，保证显示时间在50ms内，会有一定的带宽占用，按需配置）
    autoFocus: 1, //普通邮箱帐号登录，选择帐号后是否自动聚焦到密码输入框。默认否
    needMobileLogin: 1, // 需要手机帐号登录模块
    needMobileReg: 1, //需要手机注册模块
    mobileFirst: 1, // 手机帐号相关模块优先展示
    mbBtnTxt: '确定',
    mbRegGuide: '去注册',
    regMbTxt: '注册', //注册确认按钮
    // mbLogin:{'mbRegGuideUrl':'https://xxx.com'},
    regcb: function(username: string): void {
      // 可选，注册成功回调，后续要使用组件要重新初始化
      try {
        loginSuccCb()
        logger.log(username)
      } catch (e) {
        logger.log(e)
      }
      ursInitRefresh('#include-phone-password', createPasswordLogin)
    },
    logincb: function(
      _username: string,
      _isOther: boolean /*, _data: any*/,
    ): void {
      const url = '/j_spring_security_check'
      const methods = 'POST'
      try {
        requestMethod(url, methods)
          .then((data) => {
            loginSuccMethods(data)
          })
          .catch((err) => {
            logger.log(err)
          })
        logger.log('用户名:' + _username)
        logger.log('是否第三方登录:' + _isOther)
      } catch (e) {
        logger.log(e)
      }
      logger.log(_username)
      ursInitRefresh('#include-phone-password', createPasswordLogin)
    },
  })
}

function createMailLogin(): void {
  new URS({
    ...ursConfig,
    cssFiles: ursCssFiles.mailLogin,
    includeBox: 'include-mail', // 必须，登陆框的外层节点的id
    aiCapPadding: 10, //【可选】指定无感知弹出来框的padding值
    aiCapBarHeight: 40, //【可选】指定无感知弹出来框顶部的高度
    aiCapWidth: 260, //【可选】指定无感知弹出来框的宽度,最小260
    skin: 0, // 皮肤
    needPrepare: 0, //【可配】是否需要预加载（针对弹框式，在产品方DOM加载完成后初始化加载组件先行资源，保证显示时间在50ms内，会有一定的带宽占用，按需配置）
    autoFocus: 1, //普通邮箱帐号登录，选择帐号后是否自动聚焦到密码输入框。默认否
    regcb: function(username: string): void {
      // 可选，注册成功回调，后续要使用组件要重新初始化
      ursInitRefresh('#include-mail', createMailLogin)
      logger.log(username)
    },
    //邮箱账号登录相关配置
    logincb: function(
      _username: string,
      _isOther: boolean,
      /*_data: string,*/
    ): void {
      const url = '/j_spring_security_check'
      const methods = 'POST'
      try {
        requestMethod(url, methods)
          .then((data) => {
            loginSuccMethods(data)
          })
          .catch((err) => {
            logger.log(err)
          })
        logger.log('用户名:' + _username)
        logger.log('是否第三方登录:' + _isOther)
      } catch (e) {
        logger.log(e)
      }
      logger.log(_username)
      ursInitRefresh('#include-mail', createMailLogin)
    },
    placeholder: { account: '邮箱', pwd: '密码' }, //可选,邮箱登录用于更换相应placeholder的提示语
    loginText: '确定', //【可选】 邮箱帐号登录按钮文案自定义
    needUnLogin: 1, //【可选】  是否需要十天免登按钮，默认为0
    unLoginText: '自动登录', //可选
    gotoRegText: '没有网易邮箱?', //可选
    forgetpwdlink: 'https://reg.163.com/naq/findPassword#/verifyAccount', //【可选】 忘记密码找回页面链接地址
  })
}

$(function() {
  createMessageLogin()
  createPasswordLogin()
  createMailLogin()

  $('.urs-component-tab .login-way .item').on('click', function() {
    const tabNum = $(this)[0].dataset.id
    if (tabNum == '1') {
      $('.mail-tip').html('输入手机、验证码即登录，未注册将进入注册流程。')
      $('#include-message')
        .css('position', 'static')
        .siblings()
        .css('position', 'absolute')
        .css('left', '-10000px')
    } else if (tabNum == '2') {
      $('.mail-tip').html('输入手机、密码即登录，未注册将进入注册流程。')
      $('#include-phone-password')
        .css('position', 'static')
        .siblings()
        .css('position', 'absolute')
        .css('left', '-10000px')
    } else {
      $('.mail-tip').html('输入邮箱、密码即登录，未注册将进入注册流程。')
      $('#include-mail')
        .css('position', 'static')
        .siblings()
        .css('position', 'absolute')
        .css('left', '-10000px')
    }
    $(this)
      .addClass('item-active')
      .siblings()
      .removeClass('item-active')
  })
})

componentTabBroadcast.on(actions.initData, () => {
  $('#include-message').empty()
  $('#include-phone-password').empty()
  $('#include-mail').empty()
  createMessageLogin()
  createPasswordLogin()
  createMailLogin()
})
